import { Content } from "@prismicio/client";
import { PrismicRichText, SliceComponentProps } from "@prismicio/react";
import { PrismicNextImage } from "@prismicio/next";
import style from "./ProgramSatisfaction.module.scss";

export type ProgramSatisfactionProps =
  SliceComponentProps<Content.ProgramSatisfactionSlice>;

const ProgramSatisfaction = ({
  slice,
}: ProgramSatisfactionProps): JSX.Element => {
  const stars = (
    <PrismicNextImage
      className={style.stars}
      field={slice.primary.stars}
      width={116}
      height={16}
    />
  );

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={style.section}
    >
      <div className={style.wrapper}>
        <div className={style.marquee}>
          {stars}
          <div className={style.text}>
            <PrismicRichText field={slice.primary.titleDesktop} />
          </div>
          {stars}
        </div>
      </div>
    </section>
  );
};

export default ProgramSatisfaction;
